var cov_r2qrk6xzg = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/styles/index.ts",
      hash = "1138f471caad8091dcee7002ab665aa0de8e6299",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var cardLess = {};
import genaration from '../../utils/classname';
export var cardClass = (cov_r2qrk6xzg.s[0]++, genaration(cardLess, 'card'));